// extracted by mini-css-extract-plugin
module.exports = {"SecurityProtection":"SecurityProtection_SecurityProtection__rapDQ"};